import React, { Component } from 'react';
import { 
  FileText, 
  AlertCircle, 
  X, 
  Truck, 
  Clock,
  AlertTriangle,
  ArrowRight
} from 'lucide-react';

// Add Tailwind CSS
const tailwindLink = document.createElement('link');
tailwindLink.href = 'https://cdn.tailwindcss.com';
tailwindLink.rel = 'stylesheet';
if (!document.head.querySelector('link[href="https://cdn.tailwindcss.com"]')) {
  document.head.appendChild(tailwindLink);
}

class ReportsDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newReportsCount: 0,
      loading: true
    };
  }

  componentDidMount() {
    this.fetchNewReportsCount();
  }

  fetchNewReportsCount = async () => {
    try {
      this.setState({ loading: true });
      const response = await fetch('http://localhost:5000/users/mtab3a-orders/counts/');
      const data = await response.json();
      
      this.setState({
        newReportsCount: data.count || 0,
        loading: false
      });
    } catch (error) {
      console.error('Error fetching reports count:', error);
      this.setState({
        newReportsCount: 0,
        loading: false
      });
    }
  };

  handleBackClick = () => {
    window.history.back();
  };

  handleCardClick = (cardId) => {
    // Navigate to the specific page based on card type
    switch(cardId) {
      case 'new':
        console.log('Navigating to New Reports page');
        window.location.href = '/mtab3a-new';
        break;
      case 'approved':
        console.log('Navigating to Approved Reports page');
        window.location.href = '/mtab3a-miss';
        break;
      case 'rejected':
        console.log('Navigating to Rejected Reports page');
        window.location.href = '/mtab3a-kadeb';
        break;
      case 'delivery':
        console.log('Navigating to Delivery Company page');
        window.location.href = '/mtab3a-shipping';
        break;
      case 'pending':
        console.log('Navigating to Pending Reports page');
        window.location.href = '/mtab3a-mjel';
        break;
      case 'preparation_error':
        console.log('Navigating to Preparation Error page');
        window.location.href = '/mtab3a-tjheez';
        break;
      default:
        break;
    }
  };

  render() {
    const { newReportsCount, loading } = this.state;

    const cardData = [
      {
        id: 'new',
        title: 'تبليغ جديد',
        count: newReportsCount,
        icon: FileText,
        theme: 'blue',
        showCount: true
      },
      {
        id: 'approved',
        title: 'لايرد',
        icon: AlertCircle,
        theme: 'green',
        showCount: false
      },
      {
        id: 'rejected',
        title: 'كاذب',
        icon: X,
        theme: 'red',
        showCount: false
      },
      {
        id: 'delivery',
        title: 'شركة التوصيل',
        icon: Truck,
        theme: 'purple',
        showCount: false
      },
      {
        id: 'pending',
        title: 'مؤجل',
        icon: Clock,
        theme: 'amber',
        showCount: false
      },
      {
        id: 'preparation_error',
        title: 'خطأ بالتجهيز',
        icon: AlertTriangle,
        theme: 'orange',
        showCount: false
      }
    ];

    return (
      <>
        <style>{`
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }
          
          .dashboard-container {
            min-height: 100vh;
            background: linear-gradient(135deg, #f8fafc 0%, #ffffff 50%, #f1f5f9 100%);
            padding: 24px;
            direction: rtl;
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          }
          
          .header {
            margin-bottom: 32px;
            position: relative;
          }
          
          .back-button {
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            background: linear-gradient(135deg, #6b7280, #4b5563);
            color: white;
            border: none;
            border-radius: 12px;
            padding: 12px 16px;
            display: flex;
            align-items: center;
            gap: 8px;
            cursor: pointer;
            transition: all 0.3s ease;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            font-weight: 600;
          }
          
          .back-button:hover {
            background: linear-gradient(135deg, #4b5563, #374151);
            transform: translateY(-50%) translateY(-2px);
            box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
          }
          
          .header h1 {
            font-size: 2.5rem;
            font-weight: 700;
            color: #1f2937;
            margin-bottom: 8px;
          }
          
          .header p {
            color: #6b7280;
            font-size: 1.125rem;
          }
          
          .cards-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
            gap: 24px;
          }
          
          .card {
            border-radius: 16px;
            padding: 24px;
            box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
            cursor: pointer;
            transition: all 0.3s ease;
            border: 1px solid rgba(255, 255, 255, 0.5);
          }
          
          .card:hover {
            transform: translateY(-8px) scale(1.02);
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
          }
          
          .card-blue {
            background: linear-gradient(135deg, #dbeafe, #bfdbfe);
          }
          
          .card-green {
            background: linear-gradient(135deg, #dcfce7, #bbf7d0);
          }
          
          .card-red {
            background: linear-gradient(135deg, #fee2e2, #fecaca);
          }
          
          .card-purple {
            background: linear-gradient(135deg, #f3e8ff, #e9d5ff);
          }
          
          .card-amber {
            background: linear-gradient(135deg, #fef3c7, #fde68a);
          }
          
          .card-orange {
            background: linear-gradient(135deg, #fed7aa, #fdba74);
          }
          
          .icon-container {
            width: 64px;
            height: 64px;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 16px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
          }
          
          .icon-blue {
            background: linear-gradient(135deg, #3b82f6, #2563eb);
          }
          
          .icon-green {
            background: linear-gradient(135deg, #10b981, #059669);
          }
          
          .icon-red {
            background: linear-gradient(135deg, #ef4444, #dc2626);
          }
          
          .icon-purple {
            background: linear-gradient(135deg, #8b5cf6, #7c3aed);
          }
          
          .icon-amber {
            background: linear-gradient(135deg, #f59e0b, #d97706);
          }
          
          .icon-orange {
            background: linear-gradient(135deg, #ea580c, #c2410c);
          }
          
          .card-title {
            font-size: 1.25rem;
            font-weight: 700;
            margin-bottom: 8px;
          }
          
          .title-blue { color: #1d4ed8; }
          .title-green { color: #047857; }
          .title-red { color: #b91c1c; }
          .title-purple { color: #6d28d9; }
          .title-amber { color: #b45309; }
          .title-orange { color: #c2410c; }
          
          .count-container {
            display: flex;
            align-items: baseline;
            gap: 8px;
            margin-bottom: 16px;
          }
          
          .count {
            font-size: 2rem;
            font-weight: 700;
          }
          
          .count-blue { color: #2563eb; }
          .count-green { color: #059669; }
          .count-red { color: #dc2626; }
          .count-purple { color: #7c3aed; }
          .count-amber { color: #d97706; }
          .count-orange { color: #c2410c; }
          
          .count-label {
            color: #6b7280;
            font-size: 0.875rem;
          }
          
          .progress-container {
            margin-bottom: 16px;
          }
          
          .progress-bar {
            width: 100%;
            height: 8px;
            background-color: #e5e7eb;
            border-radius: 4px;
            overflow: hidden;
          }
          
          .progress-fill {
            height: 100%;
            border-radius: 4px;
            transition: width 0.3s ease;
          }
          
          .progress-blue {
            background: linear-gradient(135deg, #3b82f6, #2563eb);
          }
          
          .progress-green {
            background: linear-gradient(135deg, #10b981, #059669);
          }
          
          .progress-red {
            background: linear-gradient(135deg, #ef4444, #dc2626);
          }
          
          .progress-purple {
            background: linear-gradient(135deg, #8b5cf6, #7c3aed);
          }
          
          .progress-amber {
            background: linear-gradient(135deg, #f59e0b, #d97706);
          }
          
          .progress-orange {
            background: linear-gradient(135deg, #ea580c, #c2410c);
          }
          
          .nav-button {
            width: 100%;
            padding: 12px 16px;
            border-radius: 8px;
            color: white;
            font-weight: 600;
            border: none;
            cursor: pointer;
            transition: all 0.2s ease;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          }
          
          .nav-button:hover {
            opacity: 0.9;
            transform: translateY(-1px);
          }
          
          .button-blue {
            background: linear-gradient(135deg, #3b82f6, #2563eb);
          }
          
          .button-green {
            background: linear-gradient(135deg, #10b981, #059669);
          }
          
          .button-red {
            background: linear-gradient(135deg, #ef4444, #dc2626);
          }
          
          .button-purple {
            background: linear-gradient(135deg, #8b5cf6, #7c3aed);
          }
          
          .button-amber {
            background: linear-gradient(135deg, #f59e0b, #d97706);
          }
          
          .button-orange {
            background: linear-gradient(135deg, #ea580c, #c2410c);
          }
          
          @media (max-width: 768px) {
            .cards-grid {
              grid-template-columns: 1fr;
            }
            
            .header h1 {
              font-size: 2rem;
            }
            
            .dashboard-container {
              padding: 16px;
            }
            
            .back-button {
              position: static;
              transform: none;
              margin-bottom: 16px;
              width: fit-content;
            }
            
            .header {
              display: flex;
              flex-direction: column;
              align-items: flex-start;
            }
          }
        `}</style>
        
        <div className="dashboard-container">
          {/* Header */}
          <div className="header">
            <button 
              className="back-button"
              onClick={this.handleBackClick}
            >
              <ArrowRight size={20} />
              رجوع
            </button>
            <h1>لوحة تحكم التبليغات</h1>
            <p>إدارة ومتابعة جميع التبليغات والطلبات</p>
          </div>

          {/* Stats Cards Grid */}
          <div className="cards-grid">
            {cardData.map((card) => {
              const IconComponent = card.icon;
              return (
                <div
                  key={card.id}
                  onClick={() => this.handleCardClick(card.id)}
                  className={`card card-${card.theme}`}
                >
                  {/* Icon Container */}
                  <div className={`icon-container icon-${card.theme}`}>
                    <IconComponent size={32} color="white" />
                  </div>

                  {/* Title */}
                  <h3 className={`card-title title-${card.theme}`}>
                    {card.title}
                  </h3>

                  {/* Count - Only show for new reports */}
                  {card.showCount && (
                    <div className="count-container">
                      <span className={`count count-${card.theme}`}>
                        {loading ? '...' : card.count}
                      </span>
                      <span className="count-label">عنصر</span>
                    </div>
                  )}

                  {/* Progress Bar - Only show for new reports */}
                  {card.showCount && (
                    <div className="progress-container">
                      <div className="progress-bar">
                        <div 
                          className={`progress-fill progress-${card.theme}`}
                          style={{ width: `${Math.min((card.count / 30) * 100, 100)}%` }}
                        ></div>
                      </div>
                    </div>
                  )}

                  {/* Navigation Button */}
                  <button 
                    className={`nav-button button-${card.theme}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      this.handleCardClick(card.id);
                    }}
                  >
                    عرض التفاصيل
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      </>
    );
  }
}

export default ReportsDashboard;